import React from 'react';
import Row from '../../pro/components/orderform/Row';
import { Label } from '../../pro/components/orderform/Label';
import SelectInput from '../../pro/components/orderform/SelectInput';
import FieldValue from './FieldValue';
import { FUEL_CALC_TYPES, RATE_APPLIES, withCurrent } from '../quoteOptions';

/**
 * Per-quote Fuel Calculation / Rate Applies (masterquote fields), rendered
 * under the FSC block they govern.
 *
 * Drawer-only: the standalone quote page leaves these in its Customer Info
 * tab. The drawer decides editability (they stay open on a secured/ended
 * quote, as in V1), so a tab's own `readOnly` is deliberately NOT consulted --
 * pass `onFuelRateChange` undefined to render them read-only.
 *
 * Shared by the Direct and Dray tabs. The warehouse side used to float them in
 * a separate "Fuel & Rate Settings" card above the quote body, far from the
 * fuel type and rate they apply to.
 */
interface Props {
  fuelCalc?: string;
  rateApplies?: string;
  onFuelRateChange?: (field: 'fuelCalc' | 'rateApplies', value: string) => void;
  labelWidth: number;
}

const FuelRateSettingsRows: React.FC<Props> = ({
  fuelCalc, rateApplies, onFuelRateChange, labelWidth,
}) => {
  if (fuelCalc == null) return null;
  return (
    <>
      <div className="h-px bg-slate-100 dark:bg-slate-700 my-1" />
      {/* Both are required to save, so a blank flags itself red rather than
          only failing at Save. SelectInput forces a blank row for a value the
          option list doesn't carry, so a legacy blank shows as blank instead
          of snapping to the first choice. */}
      <Row>
        <Label width={labelWidth}>Fuel Calculation</Label>
        {onFuelRateChange
          ? <SelectInput value={fuelCalc} onChange={(v) => onFuelRateChange('fuelCalc', v)} options={withCurrent(fuelCalc, FUEL_CALC_TYPES)} ariaLabel="Fuel Calculation" highlight={fuelCalc.trim() ? undefined : 'red'} />
          : <FieldValue value={fuelCalc} />}
      </Row>
      <Row>
        <Label width={labelWidth}>Rate Applies</Label>
        {onFuelRateChange
          ? <SelectInput value={rateApplies ?? ''} onChange={(v) => onFuelRateChange('rateApplies', v)} options={withCurrent(rateApplies ?? '', RATE_APPLIES)} ariaLabel="Rate Applies" highlight={(rateApplies ?? '').trim() ? undefined : 'red'} />
          : <FieldValue value={rateApplies ?? ''} />}
      </Row>
    </>
  );
};

export default FuelRateSettingsRows;
